import { coreApi } from '../../utils/axios';
import {
  GetClinicProductsResponse,
  ClinicProduct,
  GetClinicProductSuggestionsResponse
} from './types';

export const getClinicProductSuggestions = (masterMedicineId: string) => {
  return coreApi.get<GetClinicProductSuggestionsResponse>(
    `/clinic-products/suggestions?master_medicine_id=${masterMedicineId}`
  );
};

export const createClinicProducts = (clinicMasterProductId: string, clinicProducts: ClinicProduct[]) => {
  return coreApi.post(`/clinic-master-products/${clinicMasterProductId}/products`, clinicProducts);
};

export const getClinicProducts = (clinicMasterProductId: string) => {
  return coreApi.get<GetClinicProductsResponse>(`/clinic-master-products/${clinicMasterProductId}/products`);
};

export const updateClinicProducts = (clinicProducts: ClinicProduct[], clinicId: string) => {
  return coreApi.post(`/clinic-products/updates?clinic_id=${clinicId}`, clinicProducts);
};
